import { render, staticRenderFns } from "./render_paragraph.vue?vue&type=template&id=e7e409a2&scoped=true&"
import script from "./render_paragraph.vue?vue&type=script&lang=js&"
export * from "./render_paragraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7e409a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e7e409a2')) {
      api.createRecord('e7e409a2', component.options)
    } else {
      api.reload('e7e409a2', component.options)
    }
    module.hot.accept("./render_paragraph.vue?vue&type=template&id=e7e409a2&scoped=true&", function () {
      api.rerender('e7e409a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/form/render_fields/render_paragraph.vue"
export default component.exports